import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const backendUrl = BACKEND_URL;
export const API_BASE = `${BACKEND_URL}/api`;
export const MEDIA_BASE = `${BACKEND_URL}/api/media`;

export function mediaUrlFor(item) {
  if (!item || !item.id) return "";
  const ext = item.mime === "image/gif" ? "gif" : "png";
  return `${MEDIA_BASE}/${item.id}.${ext}`;
}

export const api = axios.create({ baseURL: API_BASE });

api.interceptors.request.use((config) => {
  const token = localStorage.getItem("dt_token");
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

api.interceptors.response.use(
  (r) => r,
  (err) => {
    if (err.response?.status === 401) {
      localStorage.removeItem("dt_token");
      localStorage.removeItem("dt_user");
      if (!window.location.pathname.startsWith("/login")) {
        window.location.href = "/login";
      }
    }
    return Promise.reject(err);
  }
);
